<template>
  <div>
    <v-dialog
      scrollable
      v-model="dialogs.editLinks"
      persistent
      max-width="1050"
    >
      <material-card :title="formTitle" icon="edit" :color="$vuetify.theme.themes.light.primary">
        <v-card-text>
          <v-form ref="linksForm" v-model="valid.links">
            <v-container fluid grid-list-md>
              <v-row>
                <links-dialog
                  ref="linksform"
                  @valid-changed="valid = $event"
                  @links-changed="onLinksChanged($event)"
                  :links="links"
                ></links-dialog>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="close">{{ $t("globals.cancel") }}</v-btn>
          <v-btn
            :disabled="!linksChanged"
            color="primary"
            :loading="saving"
            @click="saveLinks"
            >{{ $t("globals.save") }}</v-btn
          >
        </v-card-actions>
      </material-card>
    </v-dialog>

    <v-dialog scrollable v-model="dialogs.edit" persistent max-width="1050">
      <material-card :title="regulatorFormTitle" icon="edit" :color="$vuetify.theme.themes.light.primary">
        <v-card-text>
          <v-form ref="form" v-model="valid.regulator">
            <v-container fluid>
              <v-row>
                <v-container class="pa-0">
                  <v-col xs="12" sm="6" md="4" lg="4">
                    <pbas-date-picker
                      v-model="editedPensionRegulator.Current.EffectiveDate"
                      :value="editedPensionRegulator.Current.EffectiveDate"
                      @update-date="
                        editedPensionRegulator.Current.EffectiveDate = $event
                      "
                      :label="$t('headers.pension_regulators.reform_date')"
                      :rules="[$rules.required]"
                      class="required"
                    ></pbas-date-picker>
                  </v-col>
                </v-container>
                <v-col cols="12">
                  <trans-textbox
                    v-model="editedPensionRegulator.Current"
                    :label="$t('globals.description')"
                    :rules="[$rules.required]"
                    field="Label"
                    class="required"
                  ></trans-textbox>
                </v-col>
                <v-col cols="12">
                  <trans-textbox
                    v-model="editedPensionRegulator.Current"
                    :label="$t('headers.pension_regulators.act')"
                    :rules="[$rules.required]"
                    field="Act"
                    class="required"
                  ></trans-textbox>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="close">{{ $t("globals.cancel") }}</v-btn>
          <v-btn
            :disabled="!valid.regulator"
            color="primary"
            :loading="saving"
            @click="savePensionRegulator"
            >{{ $t("globals.save") }}</v-btn
          >
        </v-card-actions>
      </material-card>
    </v-dialog>

    <material-card
    :title="$t('components.vuematerialdashboard.core.appbar.pension_regulators')"
      :color="$vuetify.theme.themes.light.secondary"
      icon="mdi-scale-balance"
    >
      <pbas-data-table
        :exporters="$exportersWithHistory"
        ref="table"
        :dataProvider="provider"
        :rowActions="rowActions"
        fileNamePrefix="pension-regulators"
        identifier="pensionRegulatorsTable"
        :canExpand="(item) => item.HasHistory"
        :showExpand="true"
        :generateProviderForExpanded="(item) => generateProvider(item)"
        @error="error = $event"
        :showSelect="false"
      ></pbas-data-table>
    </material-card>
    <v-snackbar
      v-model="snackbar"
      :color="color"
      :multi-line="mode === 'multi-line'"
      :timeout="timeout"
      :vertical="mode === 'vertical'"
    >
      {{ $t(message) }}
      <v-btn dark text @click="snackbar = false">{{
        $t("globals.close")
      }}</v-btn>
    </v-snackbar>
    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ErrorHandler from "../components/ErrorHandler";
import { ODataProvider as PbasOData } from "pbas-vue-components";
import PensionRegulatorsHeaders from "../headers/PensionRegulators";
import PensionRegulatorsExpansionHeaders from "../headers/PensionRegulatorsExpansion";
import { locker } from "../mixins/locker";
import { translate2 } from "../trans2";
import LinksDialog from "../components/PensionRegulators/LinksDialog.vue";
import TransTextbox from "@/components/TransTextbox.vue";
export default {
  name: "pension-regulators",
  components: {
    LinksDialog,
    TransTextbox,
    ErrorHandler,
  },
  mixins: [locker],
  data() {
    return {
      provinces: [],
      links: [],
      linksChanged: false,
      editedPensionRegulator: { Current: {} },
      loading: false,
      loaded: false,
      snackbar: false,
      color: "",
      mode: "",
      timeout: 2500,
      message: "",
      valid: {
        links: true,
        regulator: true,
      },
      provider: undefined,
      saving: false,
      rowActions: [
        {
          name: "edit",
          icon: "edit",
          title: "globals.edit",
          handler: (item) => {
            this.dialogs.edit = true;
            this.editedPensionRegulator = JSON.parse(JSON.stringify(item));
          },
        },
        {
          name: "editLinks",
          icon: "edit_attributes",
          title: "globals.edit_links",
          handler: (item) => {
            this.dialogs.editLinks = true;
            const allLangLinks = [];
            if (item.CurrentLinks.length) {
              item.CurrentLinks.forEach((l) => {
                l.LinkIdentifier = Math.random().toString();
                l.Translations.forEach((t) =>
                  allLangLinks.push({
                    LinkIdentifier: l.LinkIdentifier,
                    Name: t.Name,
                    Link: t.Link,
                    LanguageCode: t.LanguageCode,
                  })
                );
              });
            }
            this.editedPensionRegulator = JSON.parse(JSON.stringify(item));
            this.links = JSON.parse(JSON.stringify(allLangLinks));
          },
        },
      ],
      dialogs: {
        edit: false,
        editLinks: false,
      },
      headers: PensionRegulatorsHeaders,
      expansionHeaders: PensionRegulatorsExpansionHeaders,
      error: null,
    };
  },
  computed: {
    ...mapGetters("common", ["language"]),
    ...mapGetters("plansMembers", { columnsDropDownOptions: "options" }),
    formTitle() {
      return this.$t("views.pension_regulators.links.edit_{0}", [
        translate2(
          this.editedPensionRegulator && this.editedPensionRegulator.Current,
          "Label"
        ),
      ]);
    },
    regulatorFormTitle() {
      return this.$t("views.pension_regulators.edit_{0}", [
        translate2(
          this.editedPensionRegulator && this.editedPensionRegulator.Current,
          "Label"
        ),
      ]);
    },
  },
  mounted() {
    this.provider = new PbasOData(
      this.$axiosHttp,
      "pension-regulators",
      this.headers
    );
    this.provinces =
      this.columnsDropDownOptions &&
      this.columnsDropDownOptions.Models.Province;
  },
  methods: {
    ...mapActions("plansMembers", [
      "updatePensionRegulators",
      "updatePensionRegulatorLinks",
    ]),
    onLinksChanged(updatedLink) {
      const index = this.editedPensionRegulator.CurrentLinks.findIndex(
        (l) => l.LinkIdentifier === updatedLink.LinkIdentifier
      );

      this.editedPensionRegulator.CurrentLinks[index].Translations.forEach(
        (tr) => {
          if (tr.LanguageCode === updatedLink.LanguageCode) {
            tr.Name = updatedLink.Name;
            tr.Link = updatedLink.Link;
          }
        }
      );
      delete this.editedPensionRegulator.CurrentLinks[index].LinkIdentifier;
      this.linksChanged = true;
    },
    generateProvider(item) {
      let url = "pension-regulators/" + item.Id + "/history";
      return new PbasOData(this.$axiosHttp, url, this.expansionHeaders);
    },
    trans(item, field) {
      return translate2(item, field);
    },
    close() {
      this.dialogs.editLinks = false;
      this.dialogs.edit = false;
      this.editedPensionRegulator = { Current: {} };
      this.links = [];
      this.linksChanged = false;
    },
    saveLinks() {
      let item = JSON.parse(JSON.stringify(this.editedPensionRegulator));
      this.updateLinks(item);
    },
    savePensionRegulator() {
      let item = JSON.parse(JSON.stringify(this.editedPensionRegulator));
      this.update(item);
    },
    async update(item) {
      this.saving = true;
      try {
        item.Current.Label = item.Current.Translations[0].Label;
        item.Current.Act = item.Current.Translations[0].Act;
        item.Current.IdentityId = item.Id;
        await this.updatePensionRegulators({
          id: item.Id,
          payload: item.Current,
        });
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.close();
        this.$refs.table.getDataAsync();
        this.linksChanged = false;
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
    async updateLinks(item) {
      this.saving = true;
      try {
        await this.updatePensionRegulatorLinks({
          id: item.Id,
          payload: item.CurrentLinks,
        });
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.close();
        this.$refs.table.getDataAsync();
        this.linksChanged = false;
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
  },
};
</script>
